<template>
  <div>
    <b-modal
      id="detail-reimburse-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Reimburse"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tgl Pengajuan</span></th>
                <td>{{ result.reimburseDate }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Jenis Reimburse</span></th>
                <td>{{ result.reimburseCategory ? result.reimburseCategory.paramListValue : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Biaya</span></th>
                <td>{{ result.amount }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Total dicover(%)</span></th>
                <td>{{ result.totalDiscovery }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Gambar</span></th>
                <td><img style="width: 100%" alt="images_reimburse" v-bind:src="`${imageShow}`" /></td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BImg,BCol, BAvatar, BRow } from "bootstrap-vue";

export default {
  data() {
    return {
      imageShow: ''
    }
  },
  components: {
    BCol,
    BAvatar,
    BRow,
    BImg
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  watch: {
    result(value) {
      this.ReadImage(value);
    }
  },
  methods: {
    ReadImage(value) {
      // let image = localStorage.getItem('filePath');
      window.console.log(value);
      this.imageShow = value.filePath;
    }
  }
};
</script>
